import * as ActionTypes from './types.action';

export const getVacancies = () => ({
  type: ActionTypes.GET_VACANCIES_REQUESTED,
});
